import { render, staticRenderFns } from "./GoodsLowestBuy.vue?vue&type=template&id=3a01d29a&scoped=true"
import script from "./GoodsLowestBuy.vue?vue&type=script&lang=js"
export * from "./GoodsLowestBuy.vue?vue&type=script&lang=js"
import style0 from "./GoodsLowestBuy.vue?vue&type=style&index=0&id=3a01d29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a01d29a",
  null
  
)

export default component.exports